import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";
import FirmList from "./FirmList";
import { Link } from "react-router-dom";
import FirmSubUpdate from './FirmSubUpdate';
import FirmSubUserUpdate from './FirmSubUserUpdate';
import ThemeContext from "../../context/ThemeContext";
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const GET_POST = gql`
query MyQuery($firmCode: String!) {
  tbl_firm_main(where: {firm_code: {_eq: $firmCode}}) {
    updated_at
    update_user
    place
    firm_type
    firm_name
    firm_code
    created_at
    create_user
    active
  }
  tbl_firm_sub(where: {firm_main_code: {_eq: $firmCode}}) {
    firm_main_code
    firm_sub_code
    firm_sub_name
    firm_sub_type
    place
    update_user
    updated_at
    create_user
    created_at
    active
  }
  tbl_user_detail(where: {firm_main_code: {_eq: $firmCode}}) {
    firm_main_code
    firm_sub_code
    user_name
    name
    last_name
    user_type
    dpr_main_code
    dpr_sub_code
    user_lang
    data_lang
    create_user
    update_user
    created_at
    updated_at
  }
}
`;

const UPDATE_FIRM = gql`
mutation UpdateFirm(
  $firmCode: String!
  $firmName: String!
  $firmType: String!
  $place: Int!
  $fmActive: Boolean!
) {
  update_tbl_firm_main(
    where: { firm_code: { _eq: $firmCode } }
    _set: { firm_name: $firmName, firm_type: $firmType, place: $place, active: $fmActive }
  ) {
    affected_rows
  }
}
`;


const FirmDtl = () => {
  const { firm_code } = useParams();
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { firmCode: firm_code },
  });

 

  
  const [updateFirm] = useMutation(UPDATE_FIRM);

  const firmData = data && data.tbl_firm_main ? data.tbl_firm_main[0] : null;
  
  
  const [firmName, setFirmName] = useState(firmData ? firmData.firm_name : "");
  const [firmType, setFirmType] = useState(firmData ? firmData.firm_type : "");
  const [place, setPlace] = useState(firmData ? firmData.place : "");
  const [fmActive, setFmActive] = useState(firmData ? firmData.active : true);
  const [activeTab, setActiveTab] = useState(0);

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);




  const handleOpenModal = (param) => {
    setModalParam(param);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    refetch();
    
  };

  const handleOpenModal2 = (param) => {
    setModalParam(param);
    setOpenModal(true);
  };

  const handleCloseModal2 = () => {
    setOpenModal(false);
    
  };

  useEffect(() => {
    if (firmData) {
      setFirmName(firmData.firm_name);
      setFirmType(firmData.firm_type);
      setPlace(firmData.place);
      setFmActive(firmData.active);
    }
  }, [firmData]);

  const handleUpdate = () => {
    
    updateFirm({
      variables: {
        firmCode: firmData.firm_code,
        firmName: firmName,
        firmType: firmType,
        place: place,
        fmActive: fmActive,
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  };

  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-xs"
      : "text-gray-500 font-bold text-xs";
  
    return (
      <div className={statusClass}>
        {rowData.active ? "Active" : "Inactive"}
      </div>
    );
  };

  const userAndCreatedAtTemplate = (rowData) => {
    const dateTimeString = rowData.created_at; //"2023-09-27T08:45:36.735838+00:00"
    const dateObj = new Date(dateTimeString);
    const tarih = dateObj.toDateString(); // Tarih
    const saat = dateObj.toLocaleTimeString(); // Saat
  
    return (
      <div>
        <div className="text-xs">Kullanıcı: {rowData.create_user}</div>
        <div className="text-xs">Tarih: {tarih}</div>
        <div className="text-xs">Saat: {saat}</div>
      </div>
    );
  };



  const handleTabChange = (tabNumber) => {
    setActiveTab(tabNumber);
  };



  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (!firmData) {
    return <p>No firm data found.</p>;
  }
  const items = [{ label: 'Dashboard' ,url: "/", target: '_self'}, { label: 'Definitions' }, { label: 'Firm Definitions' ,url:"/sterna/definitions/main" }, { label: 'Firm List' ,url:"/sterna/FirmList" }, { label: 'Firm Details' }];

  return (

    

    
       <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100 ">
      <nav>
      <ul className="flex border-solid mt-3 rounded-md border-b outline-1">
        {items.map((item, index) => (
          <li key={index} className={`flex items-center m-1 ${index === items.length - 1 ? 'font-normal' : ''}`}>
            {index !== 0 && <span className={`mx-3 ${index === items.length - 1 ? '' : 'font-light'}`}> &gt; </span>}
            {item.url ? (
              <Link to={item.url}>{item.label}</Link>
            ) : (
              <span>{item.label}</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
      

      <div className="card min-h-[40em] ">
                
      <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
                <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
             Main Firm
            </span>
          }
          className="ml-5 flex"
        >
                    <p><div className=" p-2 ">
          <h3 className="mb-4 text-lg font-semibold">Firm Update</h3>

          <div className="card pt-1 -ml-10 -my-10 font-thin"> 
            <Fieldset>
            <p className="my-0 font-thin ">

          <div className="flex gap-4">
          <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">Firm Main Code</label>
    <InputText className="w-full" 
    id="username" value={firmData.firm_code}
    />
  </div>

  <div className="w-2/3 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Firm Main Name</label>
    <InputText className="w-full" 
    id="firmname" value={firmName} 
    onChange={(e) => setFirmName(e.target.value)} />
  </div>
  </div>

       
   
  
  <label htmlFor="firmtype" className=" flex-col my-3 ml-0 mb-5 align-items-center block font-medium text-gray-950">Firm Type </label><p></p>
  
  <div className="flex ml-0 flex-wrap gap-6">
    
    
      <div className="flex ml-0 align-items-center">
          <RadioButton inputId="ingredient1" name="Hotel" value="HTL" disabled onChange={(e) => setFirmType(e.value)} checked={firmType === 'HTL'} />
          <label htmlFor="ingredient1" className="ml-2">Hotel</label>
          
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient2" name="Agency" value="AGN" disabled onChange={(e) => setFirmType(e.value)} checked={firmType === 'AGN'} />
          <label htmlFor="ingredient2" className="ml-2">Incoming Agency</label>
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient3" name="Operator" value="OPR" disabled onChange={(e) => setFirmType(e.value)} checked={firmType === 'OPR'} />
          <label htmlFor="ingredient3" className="ml-2">Operator</label>
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient4" name="Supplier" value="SUP" disabled onChange={(e) => setFirmType(e.value)} checked={firmType === 'SUP'} />
          <label htmlFor="ingredient4" className="ml-2">Supplier</label>
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient4" name="Airlines" value="AIR" disabled onChange={(e) => setFirmType(e.value)} checked={firmType === 'AIR'} />
          <label htmlFor="ingredient5" className="ml-2">Airlines</label>
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient4" name="OTA" value="OTA" onChange={(e) => setFirmType(e.value)} checked={firmType === 'OTA'} />
          <label htmlFor="ingredient6" className="ml-2">OTA</label>
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient4" name="SPA" value="SPA" disabled onChange={(e) => setFirmType(e.value)} checked={firmType === 'SPA'} />
          <label htmlFor="ingredient6" className="ml-2">SPA</label>
      </div>
      
  </div>
  

  <div className="flex gap-3 my-5">
    
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">Firm Type</label>
    <InputText className="w-full" 
    id="firmtype" 
    name="firmtype"
    value={firmType}
    onChange={(e) => setFirmType(e.target.value)}
    readOnly/>
  </div>

  

  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="place">Place</label>
    <InputText className="w-full" 
    id="place" 
    name="place"
    value={place} 
    onChange={(e) => setPlace(e.target.value)} />
  </div>

  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Time Zone</label>
    <InputText className="w-full" 
    id="timezone" 
    name="timezone"
    value={place} 
    onChange={(e) => setPlace(e.target.value)} />
  </div>

  <div className="card  flex-col font-medium  flex justify-content-center">
  
  <label htmlFor="firmtype" 
  className=" flex-col -my-8 ml-0 mb-5 align-items-center block font-medium text-gray-950">Active </label><p></p>
  <div className="flex ml-0 flex-wrap gap-6">
  <div className="flex ml-0 align-items-center">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setFmActive(e.value)} checked={fmActive === true} />
          <label htmlFor="ingredient1" className="ml-2">Active</label>
          
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setFmActive(e.value)} checked={fmActive === false} />
          <label htmlFor="ingredient2" className="ml-2">Inactive</label>
      </div>
      </div>
      </div>  
      </div>
      

</p>
            </Fieldset>
        </div>
        
        <div className="mt-0 ">
        <Button label="Update Firm" aria-label="Update" 
          className=" p-button-sm p-button-outlined bg-purple-800 hover:bg-blue-600 text-white font-semibold  rounded-md"
          onClick={handleUpdate}  />
          
          </div>
        
             
        </div>          
      </p> 
                    </TabPanel>
                    <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
             Sub Firm
            </span>
          }
          className="ml-5 flex"
        >
          <p> <DataTable
         value={data.tbl_firm_sub } responsiveLayout="scroll"

         
        
        >
           <Column field="firm_main_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Main Firm Code</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>
          <Column field="firm_sub_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Main Sub Code</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>

          <Column field="firm_sub_name"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Main Sub Name</span>}
           style={{ textAlign: 'left', width: '20rem' }}
          >
          </Column>

          <Column field="firm_sub_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Firm Type</span>}
           style={{ textAlign: 'center', width: '7rem' }}
          >
          </Column>   

         
          <Column field="place"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Place</span>}
           style={{ textAlign: 'right', width: '6rem' }}
          >
          </Column>

          <Column field="ent_ID"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Int ID</span>}
           style={{ textAlign: 'right', width: '6rem' }}
          >
          </Column>

          <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">Status</span>}
            style={{ textAlign: 'left', width: '6rem' }}
            className="font-bold text-xs" 
          />
          <Column
           field="created_at"
           header={<span className="font-bold text-xs text-gray-900">Create</span>}
           body={(rowData) => {
           const dateTimeString = rowData.created_at;
           const dateObj = new Date(dateTimeString);
           const formattedDate = `${dateObj.toLocaleDateString()} ${dateObj.toLocaleTimeString()}`;
            const createUser = rowData.create_user;

          return (
           <div className="text-xs">
           {createUser} - {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'right', width: '6rem' }}
           />

<Column
           field="created_at"
           header={<span className="font-bold text-xs text-gray-900">Update</span>}
           body={(rowData) => {
           const dateTimeString = rowData.updated_at;
           const dateObj = new Date(dateTimeString);
           const formattedDate = `${dateObj.toLocaleDateString()} ${dateObj.toLocaleTimeString()}`;
            const createUser = rowData.update_user;

          return (
           <div className="text-xs">
           {createUser} - {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'right', width: '6rem' }}
           />

          <Column
          header={<span className="font-bold text-sm text-gray-900">Detail</span>}
          body={(rowData) => (
            <button
              onClick={() => {
                handleOpenModal(rowData.firm_sub_code);
                setTheme(rowData.firm_sub_code);
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>
        {openModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="fixed inset-0 bg-black opacity-5"></div>
        <div className="relative bg-white rounded-lg w-2/4 p-8 shadow-lg">
           
            <FirmSubUpdate />
           
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                <path d="M6.71 6.71a1 1 0 0 1 1.42 0L12 10.59l3.88-3.88a1 1 0 0 1 1.42 1.42L13.41 12l3.89 3.88a1 1 0 1 1-1.42 1.42L12 13.41l-3.88 3.89a1 1 0 0 1-1.42-1.42L10.59 12 6.71 8.12a1 1 0 0 1 0-1.41z" />
              </svg>
            </button>
          </div>
        </div>
      )}
                    </TabPanel>
                    <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 2 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
             Users
            </span>
          }
          className="ml-5 flex"
        >
                        <p><DataTable
         value={data.tbl_user_detail } responsiveLayout="scroll"

         
        
        >
           <Column field="firm_main_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Main Firm Code</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>
          <Column field="firm_sub_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Main Sub Code</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>

          <Column field="user_name"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">User Name</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>

          <Column field="name"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Name</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>   

         
          <Column field="last_name"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Last Name</span>}
           style={{ textAlign: 'left', width: '6rem' }}
          >
          </Column>

          <Column field="user_lang"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Lang</span>}
           style={{ textAlign: 'center', width: '4rem' }}
          >
          </Column>

          <Column field="data_lang"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">D Lang</span>}
           style={{ textAlign: 'center', width: '4rem' }}
          >
          </Column>

      
          <Column
           field="created_at"
           header={<span className="font-bold text-xs text-gray-900">Create</span>}
           body={(rowData) => {
           const dateTimeString = rowData.created_at;
           const dateObj = new Date(dateTimeString);
           const formattedDate = `${dateObj.toLocaleDateString()} ${dateObj.toLocaleTimeString()}`;
            const createUser = rowData.create_user;

          return (
           <div className="text-xs">
           {createUser} - {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'right', width: '6rem' }}
           />

<Column
           field="created_at"
           header={<span className="font-bold text-xs text-gray-900">Update</span>}
           body={(rowData) => {
           const dateTimeString = rowData.updated_at;
           const dateObj = new Date(dateTimeString);
           const formattedDate = `${dateObj.toLocaleDateString()} ${dateObj.toLocaleTimeString()}`;
            const createUser = rowData.update_user;

          return (
           <div className="text-xs">
           {createUser} - {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'right', width: '6rem' }}
           />

<Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">Status</span>}
            style={{ textAlign: 'left', width: '6rem' }}
            className="font-bold text-xs" 
          />

          <Column
          header={<span className="font-bold text-sm text-gray-900">Detail</span>}
          body={(rowData) => (
            <button
              onClick={() => {
                handleOpenModal2(rowData.user_name);
                setTheme(rowData.user_name);
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable>
        {openModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="fixed inset-0 bg-black opacity-5"></div>
        <div className="relative bg-white rounded-lg w-2/4 p-8 shadow-lg">
           
            <FirmSubUserUpdate />
           
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                <path d="M6.71 6.71a1 1 0 0 1 1.42 0L12 10.59l3.88-3.88a1 1 0 0 1 1.42 1.42L13.41 12l3.89 3.88a1 1 0 1 1-1.42 1.42L12 13.41l-3.88 3.89a1 1 0 0 1-1.42-1.42L10.59 12 6.71 8.12a1 1 0 0 1 0-1.41z" />
              </svg>
            </button>
          </div>
        </div>
      )}</p>
                    </TabPanel>
                </TabView>
            </div>

     
    </div>
       
 
 
);
};

export default FirmDtl;
